import React from 'react'
import Box from './box'
import Row from './row'
import Text from './text'
import isIE from '../../../util/isIE'

const LoadingIcon = require('react-loading-animation')
interface ILoader {
  status: 'loading' | 'error' | 'success' | 'updating' | 'requested'
  backgroundColor?: string
}

class Loader extends React.Component<ILoader, any> {
  public render() {
    if (
      (this.props.status && this.props.status === 'loading') ||
      (this.props.status && this.props.status === 'updating') ||
      (this.props.status && this.props.status === 'requested')
    ) {
      return (
        <Box css={{ position: 'relative' }}>
          <Box css={style(this.props.backgroundColor)}>
            <Row
              items="center"
              content="center"
              css={{ width: '100%', height: '100%' }}
            >
              <Box>{isIE() ? <Text>Loading</Text> : <LoadingIcon />}</Box>
            </Row>
          </Box>
          <Box>{this.props.children}</Box>
        </Box>
      )
    }
    return <Box>{this.props.children}</Box>
  }
}

const style = backgroundColor => {
  return {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: '99',
    backgroundColor: backgroundColor
      ? backgroundColor
      : 'rgba(153, 153, 153, 0.5)'
  }
}

export default Loader
